import { withStyles } from '@mui/styles';
import React, { Component } from 'react';
// import logoImage from './logo.svg';
import logoImage from '../login/ilocalbox-logo.svg';

const styles = theme => ({
    logo: {
        textAlign: 'center',
    },
    logoImageSize: {
      objectFit: 'contain',
      marginLeft: 'auto',
      marginRight: 'auto',
      display: 'block',

      /* Extra small devices (phones, 600px and down) */
      '@media only screen and (max-width: 600px)': {
          width: '70%',
      },
      
      /* Small devices (portrait tablets and large phones, 600px and up) */
      '@media only screen and (min-width: 600px)': {
          width: '70%',
      },
      
      /* Medium devices (landscape tablets, 768px and up) */
      '@media only screen and (min-width: 768px)': {
          width: '50%',
      },
      
      /* Large devices (laptops/desktops, 992px and up) */
      '@media only screen and (min-width: 992px)': {
          width: '40%',
      },
      
      /* Extra large devices (large laptops and desktops, 1200px and up) */
      '@media only screen and (min-width: 1200px)': {
          width: '25%',
          paddingTop: '1rem',
      },
    },
  });

class Logo extends Component {
  render() {
    const { classes } = this.props;
    return (
    <div className={classes.logo}>
        <img className={classes.logoImageSize} src={logoImage} alt='logo' />
    </div>
    );
  }
}

export default withStyles(styles)(Logo);



// WEBPACK FOOTER //
// ./src/components/logo/index.js